"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DealBoardSearchActionTypes = _interopRequireDefault(require("./DealBoardSearchActionTypes"));

var _createSearchActions = _interopRequireDefault(require("../../flux/elasticSearch/createSearchActions"));

var _default = (0, _createSearchActions.default)(_DealBoardSearchActionTypes.default);

exports.default = _default;
module.exports = exports.default;